<template>
  <a-modal v-model="visible" title="变更记录" width="1400px">
    <a-table
        :columns="columns"
        :data-source="recordList"
        :pagination="false"
        rowKey="id"
        v-if="recordList.length > 0">
      <span slot="bizOccurTime" slot-scope="text">{{ text ? text : '' }}</span>
      <span slot="subType" slot-scope="text">{{ subTypeMap[text] || text }}</span>
      <span slot="bizDirection" slot-scope="text">
        <a-tag v-if="text === 'increase'" color="green">增加</a-tag>
        <a-tag v-else-if="text === 'decrease'" color="red">减少</a-tag>
        <a-tag v-else color="gray">不涉及</a-tag>
      </span>
      <span slot="financeDirection" slot-scope="text">
        <a-tag v-if="text === 'increase'" color="green">增加</a-tag>
        <a-tag v-else-if="text === 'decrease'" color="red">减少</a-tag>
        <a-tag v-else color="gray">不涉及</a-tag>
      </span>
      <span slot="beforeExpireDate" slot-scope="text">{{ text ? text : '' }}</span>
      <span slot="startDate" slot-scope="text">{{ text ? text : '' }}</span>
      <span slot="days" slot-scope="text">{{ text != null ? (text > 0 ? '+' + text : text) : '' }}</span>
      <span slot="afterExpireDate" slot-scope="text">{{ text ? text : '' }}</span>
      <span slot="payAmount" slot-scope="text, record">{{ formatAmount(text, record) }}</span>
      <span slot="payInfo" slot-scope="text, record">
        {{ payPlatformMap[record.payPlatform] || '' }}{{ payMethodMap[record.payMethod] || '' }}
      </span>
      <span slot="comment" slot-scope="text">{{ text ? text : '' }}</span>
    </a-table>
    <p v-else>无记录</p>
    <template slot="footer">
      <a-button key="submit" type="primary" @click="handleOk">
        确定
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import userBizRecordService from '@/service/userBizRecord'

export default {
  data() {
    return {
      visible: false,
      recordList: [],
      subTypeMap: {
        onlineRechargeMonth: '线上充值-月卡',
        onlineRechargeYear: '线上充值-年卡',
        onlineRechargeSemester: '线上充值-学期卡',
        offlineRechargeMonth: '线下充值-月卡',
        offlineRechargeYear: '线下充值-年卡',
        offlineRechargeSemester: '线下充值-学期卡',
        offlineRechargeReplenish: '线下充值-补差价',
        onlineRechargeRefund: '线上充值退订-退款且退有效期',
        onlineRechargeRefundAmount: '线上充值退订-仅退款',
        offlineRechargeRefund: '线下充值退订-退款且退有效期',
        experiencePresent: '体验赠送',
        promotionPresent: '促销赠送',
        otherIncrease: '其他原因会员增加',
        otherDecrease: '其他原因会员减少',
      },
      payPlatformMap: {
        weixin: '微信支付',
        guotongxingyi: '国通星驿',
        unknown: '未知',
      },
      payMethodMap: {
        weixinMini: '(小程序)',
        weixinScan: '(扫码)',
        guotongxingyi: '(收款码)',
        unknown: '',
      },
      columns: [
        {
          title: '业务发生时间',
          dataIndex: 'bizOccurTime',
          scopedSlots: { customRender: 'bizOccurTime' },
          align: 'center',
          width: 160,
        },
        {
          title: '业务类型',
          dataIndex: 'subType',
          scopedSlots: { customRender: 'subType' },
          align: 'center',
          width: 180,
        },
        {
          title: '业务方向',
          dataIndex: 'bizDirection',
          scopedSlots: { customRender: 'bizDirection' },
          align: 'center',
          width: 80,
        },
        {
          title: '变更前有效期',
          dataIndex: 'beforeExpireDate',
          scopedSlots: { customRender: 'beforeExpireDate' },
          align: 'center',
          width: 120,
        },
        {
          title: '变更起算日期',
          dataIndex: 'startDate',
          scopedSlots: { customRender: 'startDate' },
          align: 'center',
          width: 120,
        },
        {
          title: '天数',
          dataIndex: 'days',
          scopedSlots: { customRender: 'days' },
          align: 'center',
          width: 70,
        },
        {
          title: '变更后有效期',
          dataIndex: 'afterExpireDate',
          scopedSlots: { customRender: 'afterExpireDate' },
          align: 'center',
          width: 120,
        },
        {
          title: '财务方向',
          dataIndex: 'financeDirection',
          scopedSlots: { customRender: 'financeDirection' },
          align: 'center',
          width: 80,
        },
        {
          title: '支付/退款金额（元）',
          dataIndex: 'payAmount',
          scopedSlots: { customRender: 'payAmount' },
          align: 'center',
          width: 110,
        },
        {
          title: '支付/退款方式',
          scopedSlots: { customRender: 'payInfo' },
          align: 'center',
          width: 140,
        },
        {
          title: '业务描述',
          dataIndex: 'comment',
          scopedSlots: { customRender: 'comment' },
          align: 'center',
        },
      ],
    };
  },
  methods: {
    formatAmount(text, record) {
      if (text == null) return '';
      if (record.bizDirection === 'decrease' || record.financeDirection === 'decrease') {
        return '-' + text;
      }
      return text;
    },
    showModal(userId) {
      this.visible = true;
      userBizRecordService.queryListByUserId({ userId }).then((res) => {
        this.recordList = res.data;
      });
    },
    handleOk() {
      this.visible = false;
    },
  },
};
</script>
